import React, { useState, useEffect } from 'react';
import dashboard_svg from "../../common/icons/svg/dashboard.svg";
import dashboard_svg_active from "../../common/icons/svg/dashboard-active.svg";
import alarm_svg from "../../common/icons/svg/alarm.svg";
import setting_svg from "../../common/icons/svg/setting.svg";
import info_svg from "../../common/icons/svg/info.svg";
import patient_book_svg from "../../common/icons/svg/patient-book-sidebar.svg";
import patient_book_svg_active from "../../common/icons/svg/patient-book-sidebar-active.svg";
import signout_svg from "../../common/icons/svg/signout.svg";
import { HOME_PAGE, PAGE_CONST } from '../../common/constant/page-constants';
import { SIDEBAR_ICON } from '../../common/constant/common-constants';
import "./Sidebar.scss";
import { useNavigate } from 'react-router-dom';
import { redirect } from '../../common/utils/RedirectionUtils';
import { connect } from 'react-redux';
import { sidebarActiveIconAction } from '../../modules/actions/action';

function SideBar(props) {
    const [signoutModal, setSignoutModal] = useState(false);
    const navigate = useNavigate();
    const [activeIcon, setActiveIcon] = useState(props.activeSidebarIcon);

    const handleHelpClick = (event) => {
        if (!signoutModal) {
            event.stopPropagation();
            setSignoutModal(true);

            console.log("clicked signout in if");
            let element = document.getElementById('signout-modal-container');

            window.addEventListener('click', function (e) {

                console.log("inside event listener");
                if (element && element.contains(e.target)) {
                    console.log("inside click");
                } else {
                    console.log("outside click");
                    setSignoutModal(false);
                }
            });
            return;
        }

    }
    const handleSignoutCancel = () => {
        setSignoutModal(!signoutModal)
    }
    const handleSigoutClick = () => {

        redirect(navigate, PAGE_CONST.LOGIN)
        console.log("signout was clicked");
    }
    const handleIconClick = (item) => {
        props.sidebarActiveIconAction(item);
        redirect(navigate, item);
        setActiveIcon(item);
    }

    return (
        <div className="side-bar">
            <div className="sidebar-icon-container">
                <div className="top-icon-container">
                    {/* <div className="dashboard-icon-container icon-container"> */}
                    {activeIcon === SIDEBAR_ICON.HOME_PAGE ?
                        <img src={dashboard_svg_active} alt="dashboard svg" className="activeIcon" /> :
                        <img src={dashboard_svg} alt="dashboard svg" onClick={(event) => handleIconClick(SIDEBAR_ICON.HOME_PAGE)} />}
                    {activeIcon === SIDEBAR_ICON.PATIENT_BOOK ?
                        <img src={patient_book_svg_active} alt="dashboard svg" className="activeIcon" /> :
                        <img src={patient_book_svg} alt="dashboard svg" onClick={(event) => handleIconClick(SIDEBAR_ICON.PATIENT_BOOK)} />}
                    {/* <img src={patient_book_svg} alt="dashboard svg" onClick={(event) => handleIconClick(SIDEBAR_ICON.PATIENT_BOOK)} />} */}
                    {/* </div> */}
                    {/* <div className="alarm-icon-container icon-container">
                        <img src={alarm_svg} alt="alarm svg" onClick={() => console.log("alarm clicked !! ")} />
                    </div>
                    <div className="setting-icon-container icon-container">
                        <img src={setting_svg} alt="setting svg" onClick={() => console.log("setting clicked !! ")} />
                    </div>
                    <div className="help-icon-container icon-container">
                        <img src={info_svg} alt="help svg" onClick={() => console.log("help clicked !! ")} />
                    </div> */}
                </div>
                <div className="bottom-icon-container">
                    <div className="help-icon-container icon-container">
                        <img
                            src={signout_svg}
                            alt="signout svg"
                            onClickCapture={(event) => handleHelpClick(event)}
                        />
                    </div>
                </div>
            </div>
            {signoutModal &&
                <div className='signout-modal-container'
                    id="signout-modal-container">
                    <div className='modal-content-container'>
                        <span className='signout-text'>Sign Out ?</span>
                        <span className='signout-confirm-text'>Are you sure you want to Sign Out?</span>
                        <span className='signout-final-statement'>
                            You can Sign In with the credentials provided to access the dashboard.
                        </span>
                        <div className='signout-btn-container'>
                            <div className='common-signout-btn' onClick={handleSignoutCancel}>Cancel</div>
                            <div className='common-signout-btn active-signout-btn' onClick={handleSigoutClick}>SignOut</div>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

const mapStateToProps = state => {
    return {
        activeSidebarIcon: state.configReducer.config.activeSidebarIcon,
    }
}

const mapDispatchToProps = (dispatch) => {

    return {
        sidebarActiveIconAction: (payload) => dispatch(sidebarActiveIconAction(payload)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SideBar);

